import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MapPin, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API}/projects`);
        setProjects(response.data);
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <div className="pt-20" data-testid="projects-page">
      {/* Hero */}
      <section className="bg-[#1e3a5f] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p className="text-[#c9a227] uppercase tracking-[0.2em] text-sm font-semibold mb-4">
              Portfolio
            </p>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold text-white mb-6">
              Nos Projets
            </h1>
            <p className="text-gray-300 text-lg leading-relaxed">
              Découvrez une sélection de nos réalisations en division immobilière 
              et accompagnement de sorties d'indivision.
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="w-8 h-8 border-4 border-[#1e3a5f] border-t-transparent rounded-full loading-spinner"></div>
            </div>
          ) : projects.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <div 
                  key={project.id}
                  className="group bg-white border border-gray-100 overflow-hidden card-hover shadow-sm"
                  data-testid={`project-card-${index}`}
                >
                  <div className="relative img-zoom">
                    <img 
                      src={project.image_url}
                      alt={project.title}
                      className="w-full h-64 object-cover"
                    />
                    <div className="absolute top-4 right-4 bg-[#c9a227] text-white text-xs uppercase tracking-wider px-3 py-1">
                      {project.status}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1e3a5f] mb-3">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-4 text-gray-500 text-sm mb-4">
                      <span className="flex items-center gap-1">
                        <MapPin size={14} />
                        {project.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <Calendar size={14} />
                        {project.year}
                      </span>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {project.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">Aucun projet pour le moment.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 bg-[#f8f9fa]">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-6">
            Vous Avez un Projet Similaire ?
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed mb-10">
            Contactez-nous pour discuter de votre projet de division immobilière 
            ou de sortie d'indivision.
          </p>
          <Link to="/contact">
            <Button 
              className="bg-[#1e3a5f] text-white hover:bg-[#162a45] rounded-none px-10 py-4 uppercase tracking-wider text-sm font-semibold"
              data-testid="projects-cta-btn"
            >
              Discuter de Mon Projet
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Projects;
